import { Link } from "react-router-dom";
import {
  GraduationCap,
  Building2,
  UserRound,
  ArrowUpRight,
} from "lucide-react";

const SOLUTIONS = [
  {
    icon: GraduationCap,
    title: "Universities",
    body: "Give cohorts hands-on cyber ranges with per-student progress, managed enrolment, and instructor oversight.",
    action: "University login",
    href: "/university/login",
  },
  {
    icon: Building2,
    title: "Enterprises",
    body: "Upskill security teams with private team challenges, role-based access, and organization-wide reporting.",
    action: "Company login",
    href: "/company/login",
    featured: true,
  },
  {
    icon: UserRound,
    title: "Individuals",
    body: "Students and professionals can practise on their own, track achievements, and build a verifiable skill set.",
    action: "Create an account",
    href: "/register",
  },
];

export default function Solutions() {
  return (
    <section id="solutions" className="relative py-16 lg:py-24">
      <div className="mx-auto max-w-350 px-5 md:px-10">
        <div className="lp-reveal mx-auto max-w-2xl text-center">
          <div className="mb-4 flex items-center justify-center gap-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-(--color-primary)">
            <span className="h-px w-6 bg-(--color-primary)" />
            Solutions
            <span className="h-px w-6 bg-(--color-primary)" />
          </div>
          <h2 className="qv-glitch text-[34px] sm:text-[42px] font-medium leading-tight tracking-tight text-(--color-text-primary)">
            One platform, tailored to{" "}
            <span className="lp-highlight">every team</span>
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-(--color-text-secondary)">
            Dedicated portals and access models for the way your organization
            learns and operates.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
          {SOLUTIONS.map((item, i) => {
            const Icon = item.icon;
            const dir = ["lp-left", "lp-down", "lp-right"][i % 3];
            return (
              <div
                key={item.title}
                style={{ transitionDelay: `${i * 90}ms` }}
                className={`lp-reveal ${dir} qv-card group relative flex flex-col p-7 ${
                  item.featured ? "qv-card-accent" : ""
                }`}
              >
                <span className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl border border-(--color-border-solid) bg-(--color-primary-50) text-(--color-primary)">
                  <Icon className="h-6 w-6" />
                </span>
                <h3 className="text-xl font-semibold text-(--color-text-primary)">
                  {item.title}
                </h3>
                <p className="mt-3 flex-1 text-[13.5px] leading-relaxed text-(--color-text-secondary)">
                  {item.body}
                </p>
                <Link
                  to={item.href}
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-(--color-primary) transition-colors"
                >
                  {item.action}
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
